/*@ngInject*/
const DocumentController = function ($scope, $stateParams, $rootScope, coreConstant,
                                                    attachmentMediator, uiPerformanceLoggerConstant,
                                                    attachmentUtil, formViewerConstant) {
    $scope.viewModel = {
        attachmentId: '',
        attachmentName: '',
        isHTMLDocument: false,
        attachmentLinkURL: ''
    };

    attachmentMediator.retrieveAttachment($stateParams.attachmentId).then(function (attachment) {
        let att = attachment.Attachment;

        $scope.viewModel.attachmentName = att.name;
        $scope.viewModel.attachmentId = att.id;
        $scope.viewModel.isHTMLDocument = _.endsWith(att.name, '.html') || _.endsWith(att.name, '.htm');
        attachmentUtil.getAttachmentLinkURL(att.id, att.name).then((url) => {
            $scope.viewModel.attachmentLinkURL = url;
        });

        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.SHOW_DOCUMENT, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.GET_RATE, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.REQUEST_BINDING, coreConstant.uiPeformanceLogger.SUCCESS);
        $rootScope.$broadcast(formViewerConstant.event.FORM_STRUCTURE_CHANGED);
        $rootScope.$broadcast(formViewerConstant.event.FORM_LAZY_RENDERING_END);
    });

};
angular.module('gw-um-submission')
    .controller('documentController', DocumentController);
